export function getDeviceFingerprint(): string {
  // Non-sensitive, heuristic fingerprint for MFA remember_device
  const data = [
    navigator.userAgent,
    navigator.language,
    String(screen.width),
    String(screen.height),
    String(screen.colorDepth)
  ].join('|')
  // Simple stable hash
  let hash = 0
  for (let i = 0; i < data.length; i++) {
    hash = (hash << 5) - hash + data.charCodeAt(i)
    hash |= 0
  }
  return `dev_${Math.abs(hash)}`
}

